import { loadStatusModulos } from "../statusModulos";
import { inicializarDeshabilitarVersionesYsocial } from "../../utils/inicializarUtils";
import { YsocialActionType } from "../../interfaces/global-state/ysocial.action.type.enum";

export const deshabilitarModulosPorVersionesYsocial = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch
) => {
    let version = '3.9.0';
    let aplicacion = 'ysocial';

    try {
        const deshabilitacion = await loadStatusModulos(version, aplicacion, apiRequest);
        deshabilitacion.deshabilitarGeolocalizacion = true;
        dispatch({
            type: YsocialActionType.setStatusModulos,
            statusModulos: deshabilitacion
        });
    } catch (error) {
        let deshabilitacion = inicializarDeshabilitarVersionesYsocial();
        deshabilitacion.version = version;
        deshabilitacion.aplicacion = aplicacion;
        dispatch({
            type: YsocialActionType.setStatusModulos,
            statusModulos: deshabilitacion
        });
    }
}